import routesComponent from './routes.component';
import RoutesCreate from './create'
import RoutesEdit from './edit'
import RoutesAll from './all'

let routesModule = angular.module('routes', [
  RoutesCreate,
  RoutesEdit,
  RoutesAll
])

  .component('routes', routesComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      .state('routes.edit', {
        url: '/edit/:id/:day',
        component: 'routesedit',
        // data: {
        //   requireACL: 'setting-routes.edit'
        // }
      })

      .state('routes.create', {
        url: '/create',
        component: 'routescreate',
        data: {
          requireACL: 'setting-routes.create'
        }
      })

      .state('routes.all', {
        url: '/all/:page',
        component: 'routesall',
        data: {
          requireACL: 'setting-routes.view'
        }
      })
  })

  .name;

export default routesModule;


// WEBPACK FOOTER //
// ./client/app/components/routes/index.js